// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { CompareNamesResponse } from '@coa/app/shared/select-items-shared/models/compare-stores.response';
import { SelectableFeature } from '@coa/app/shared/select-items-shared/models/selectable-feature';

@Pipe({
  name: 'compareName',
})
export class CompareNamePipe implements PipeTransform {

  transform(value: string, items: CompareNamesResponse, selectableFeature: SelectableFeature): any {
    if (value && items) {
      const element = items.find((item) => item.id.toString() === value.toString());
      return element
        ? element.name + (selectableFeature === SelectableFeature.STORES ? ', ' + element.subName : '')
        : '';
    }
    return value;
  }

}
